<template>
  <button
    :style="styleObject"
    @mouseover="changeHover(true)"
    @mouseout="changeHover(false)"
    v-bind:class="{ hasError: !isValid }"
    v-on:click="go($event)"
  >
    <p>
      <img v-bind:class="{ rotate: reversed }" :src="imagePath" width="20" height="20" />
      <span ref="text">{{ text.toUpperCase() }}</span>
    </p>
  </button>
</template>

<script>
export default {
  name: 'Button',
  data() {
    return {
      isHover: false,
    };
  },
  props: ['text', 'href', 'image', 'color', 'isValid', 'reversed', 'step'],
  watch: {
    step: {
      handler() {
        if (!this.isValid) {
          this.changeHover(false);
        }
      },
      deep: true,
    },
  },
  computed: {
    styleObject: function() {
      return {
        '--backgroundColor': this.color ? this.color : 'white',
        '--width': this.buttonWidth,
        '--margin': this.buttonMargin,
      };
    },
    buttonWidth() {
      return this.isHover ? 60 + this.$refs.text.clientWidth + 'px' : '60px';
    },
    imagePath() {
      return require(`../../../assets/${this.isHover ? 'ic-arrow-link-white.svg' : 'ic-arrow-link.svg'}`);
    },
    buttonMargin() {
      return this.isHover ? 140 - this.$refs.text.clientWidth + 'px' : '140px';
    },
  },
  methods: {
    changeHover(value) {
      this.isHover = value;
    },
    go() {
      if (!this.href) {
        this.$emit('go');
        return;
      }

      this.$router.push(this.href).catch(err => {
        this.$log.error(err);
      });
    },
  },
};
</script>

<style scoped>
button {
  display: block;
  float: left;
  color: black;
  line-height: 22px;
  letter-spacing: 0.46px;
  font-weight: 300;
  padding-left: 20px;
  font-size: 16px;
  background-color: var(--backgroundColor);
  border: none;
  cursor: pointer;
  transition: width, 1s, 1s;
  margin-right: var(--margin);
  overflow: visible;
  text-align: left;
  width: var(--width);
}

button::after {
  margin-right: 20px;
}

button:hover > p {
  color: white;
}

button:hover {
  background-color: #5e6a71;
  border: none;
}

p {
  font-size: 1vw;
  display: inline-flex;
  width: 150px;
  position: relative;
  white-space: nowrap;
}
img {
  margin-right: 10px;
}
button:focus {
  outline: 0;
}
.hasError {
  opacity: 0.4;
  cursor: not-allowed;
}
.rotate {
  transform: rotate(180deg);
}
</style>
